import React from 'react';
import NoPagePlaceholder from '../../components/Placeholders/404';

const NoPage = () => {
    return (
        <NoPagePlaceholder />
    )
};

export default NoPage;